export default __webpack_public_path__ + "static/Plots0018-9bf97a3df074a9357299d49c97c968b1.jpg";